import React, { Component } from "react";
import { changeUser } from "../redux/actions";
import { connect } from "react-redux";
import AlphaWarning from "./AlphaWarning";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faUser, faKey } from "@fortawesome/free-solid-svg-icons";

/* Using Uncontrolled form inputs here; it's faster. https://reactjs.org/docs/uncontrolled-components.html */
export class UnconnectedPageSettings extends Component {

	constructor(props) {
		super(props);
		this.input_nick_name = React.createRef();  
		this.input_room_key = React.createRef();  
		this.input_room_password = React.createRef();  
	}

	saveChanges(event) {
		this.props.changeUser("nick_name",this.input_nick_name.current.value);
		this.props.changeUser("room_key",this.input_room_key.current.value.toUpperCase());
		event.preventDefault();
	}

	render() {
		return (
			<div className='section'>
				<div className='container'>
					<h1 className='title'>Couchpile: watch anything together</h1>

					<form onSubmit={this.saveChanges.bind(this)}>
						<div className="field">
							<label className="label">Nickname</label>
							<div className="control has-icons-left">
								<input className="input" type="text" placeholder="" defaultValue={this.props.nick_name} ref={this.input_nick_name}/>
								<span className="icon is-small is-left">
									<FontAwesomeIcon icon={faUser} size="lg" fixedWidth/> 
								</span>
							</div>
							<p className="help">Shown to others in the room</p>
						</div>

						<div className="field">
							<label className="label">Room key</label>
							<div className="control has-icons-left">
								<input className="input" type="text" placeholder="" defaultValue={this.props.room_key}  ref={this.input_room_key}/>
								<span className="icon is-small is-left">
									<FontAwesomeIcon icon={faKey} size="lg" fixedWidth/> 
								</span>
							</div>
							<p className="help">Enter the key you were given, or make something up to create a new room.</p>
						</div>

						<div className="field">
							<div className="control">
								<input type="submit" className="button is-primary" value="Enter room"></input>
							</div>
						</div>
					</form>

					<AlphaWarning/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({ nick_name: state.user.nick_name, room_key: state.user.room_key });

export const PageSettings = connect(mapStateToProps,{ changeUser })(UnconnectedPageSettings);
